import BasicRepository from "./basicRepository";
import Client from "../client";
import FeedResource from "../resources/feedResource";
import { ResourceCollection } from "../resources";
import PackageResource, {PackageDescriptionResource, PackageVersionResource} from "../resources/packageResource";

class FeedRepository extends BasicRepository<FeedResource, FeedResource> {
    constructor(client: Client) {
        super("Feeds", client);
    }

    searchPackages(feed: FeedResource, searchOptions: {
        term: string,
        take?: number,
        skip?: number
    }): Promise<ResourceCollection<PackageDescriptionResource>> {
        return this.client.get(feed.Links["SearchPackagesTemplate"], searchOptions);
    }

    searchPackageVersions(feed: FeedResource, packageId: string, searchOptions: PackageSearchOptions): Promise<ResourceCollection<PackageVersionResource>> {
        return this.client.get(feed.Links["SearchPackageVersionsTemplate"], {packageId, ...searchOptions});
    }

    getNotes(feed: FeedResource, packageId: string, version: any) {
        return this.client.getRaw(feed.Links["NotesTemplate"], { packageId, version });
    }
}
interface  PackageSearchOptions {
    take?: number;
    skip?: number;
    includePreRelease?: boolean;
    preReleaseTag?: string;
    versionRange?: string;
    includeReleaseNotes?: boolean;
    filter?: string;
}
export {PackageSearchOptions};
export default FeedRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/feedRepository.ts